import React from "react";
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { HiMail } from "react-icons/hi";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { HiOutlineBriefcase } from "react-icons/hi";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { HiOutlinePhone } from "react-icons/hi";
import { HiOutlineMail } from "react-icons/hi";

import { useTranslation } from 'react-i18next';
import NavBAr from "../components/NavBar"
function HomePage() {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col">
            <NavBAr />
            <div className="flex flex-col justify-between ">
                <div className="flex flex-col justify-center items-center my-16">
                    <div className="unselectable">
                        <p className="text-2xl font-mono my-4 text-center text-[#66B933] drop-shadow-glowGreen">{t('greeting-intro')}</p>
                        <h1 className="text-7xl font-bold my-4 text-center text-[#66B933] drop-shadow-glowGreen">{t('my-name')}</h1>
                        <p className="text-4xl font-mono my-4 text-center text-[#66B933] drop-shadow-glowGreen">{t('my-title')}</p>
                    </div>
                    <div className="flex justify-center">
                        <div className="flex justify-between items-center min-w-60">
                            <div className="btn cursor-pointer">
                                <a href="mailto:sinaranaei@protonmail.com" target="_blank">
                                    <HiMail size={50} className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite" />
                                </a>
                            </div>
                            <div className="btn cursor-pointer">
                                <a href="https://www.linkedin.com/in/sina-ranaei" target="_blank">
                                    <AiFillLinkedin size={50} className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite" />
                                </a>
                            </div>
                            <div className="btn cursor-pointer">
                                <a href="https://github.com/sinaranaei" target="_blank" >
                                    <AiFillGithub size={50} className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="about-section" className="mx-10 mt-60 unselectable">
                        <p className="text-3xl font-semibold my-4 text-center text-white 
                        drop-shadow-glowWhite">
                            About
                        </p>
                        <div className="py-2 px-6 ">
                            <p className="text-xl font-normal my-4 text-center text-white 
                        drop-shadow-glowWhiteSm">
                                Dynamic software engineer with a strong background in full-stack web development. Skilled in C#, .NET, .NET Core, Python with Django, MSSQL, HTML, CSS, JavaScript, and React.js. Known for adaptability and problem-solving, delivering scalable solutions and thriving in challenging environments. A collaborative team player with a passion for continuous learning and innovation. Ready to tackle complex projects and drive business success through technology.
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col justify-center">
                        <div id="experience-section" className="mx-4 my-8 unselectable ">
                            <p className="flex justify-center items-center  text-3xl font-semibold my-4 text-center text-white 
                                        drop-shadow-glowWhite">
                                <HiOutlineBriefcase size={30} className="mx-4" />
                                Experience
                            </p>

                            <div className="py-4 px-6 ">
                                <p className="text-xl font-normal text-center text-white 
                                        drop-shadow-glowWhiteSm">
                                    .NET Developer
                                    <br />
                                    Elmo Sanat Co · Full-time
                                    <br />
                                    Jan 2024 - Apr 2024 · 4 months
                                    <br />
                                    Tehran Province, Iran · Hybrid
                                    <br />
                                    1-	Developed a dynamic PWA Admin Dashboard utilizing React for frontend and .NET API for backend integration, enhancing data accessibility and user experience.
                                    <br />
                                    2-	Spearheaded the visualization of complex data sets and streamlined reporting functionalities on the dashboard, facilitating informed decision-making processes for stakeholders.
                                    <br />
                                    3-	Played a pivotal role in resolving technical issues within legacy .NET Framework 4.1 software, optimizing SQL queries, and introducing new features to enhance system efficiency and performance.
                                </p>
                            </div>
                        </div>

                        <div className="mx-2 my-8 unselectable ">
                            <p className="flex justify-center items-center  text-3xl font-semibold my-4 text-center text-white 
                        drop-shadow-glowWhite">
                                <HiOutlineAcademicCap size={30} className="mx-4" />
                                Education
                            </p>
                            <div className="py-4 px-6">
                                <p className="text-xl font-normal text-center text-white 
                        drop-shadow-glowWhiteSm ">
                                    Bachelor's degree, Computer Science
                                    <br />
                                    Yazdanpanah Faculty of Sanandaj /Technical & Vocational University of Kurdistan
                                    <br />
                                    2021 – 2025
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="contact-section" className="flex flex-col justify-center my-20 min-w-[100%]">
                        <p className="text-3xl font-semibold my-4 text-center text-white drop-shadow-glowWhite">
                            Contact Me
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite">
                                <a href="tel:+989180883016" className="hover:text-[#66B933]">
                                    <p className="flex flex-col justify-center items-center text-2xl font-semibold my-4 text-center text-white drop-shadow-glowWhiteSm hover:text-[#66B933]">
                                        <HiOutlinePhone size={50} className="mx-4" />
                                        +989180883016
                                    </p>
                                </a>
                            </div>
                            <div className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite">
                                <a href="mailto:sinaranaei@protonmail.com">
                                    <p className="flex flex-col justify-center items-center text-2xl font-semibold my-4 text-center text-white drop-shadow-glowWhiteSm hover:text-[#66B933]">
                                        <HiOutlineMail size={50} className="mx-4" />
                                        sinaranaei@protonmail.com
                                    </p>
                                </a>
                            </div>
                            <div className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite">
                                <a href="https://www.linkedin.com/in/sina-ranaei">
                                    <p className="flex flex-col justify-center items-center text-2xl font-semibold my-4 text-center text-white drop-shadow-glowWhiteSm hover:text-[#66B933]">
                                        <AiFillLinkedin size={50} className="mx-4" />
                                        LinkedIn
                                    </p>
                                </a>
                            </div>
                            <div className="text-[#FFFFFF] hover:text-[#66B933] drop-shadow-glowWhite">
                                <a href="https://github.com/sinaranaei">
                                    <p className="flex flex-col justify-center items-center text-2xl font-semibold my-4 text-center text-white drop-shadow-glowWhiteSm hover:text-[#66B933]">
                                        <AiFillGithub size={50} className="mx-4" />
                                        GitHub
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>



                </div>

                <div className="flex justify-center unselectable">
                    <p className="items-center text-sm font-mono my-4 text-center text-[#66B933] 
                                    drop-shadow-glowGreenMd">
                        Powered By Passion
                    </p>
                    <span className="items-center text-sm font-mono my-4 text-center text-[#66B933] 
                                    drop-shadow-glowGreenMd">
                        <HiOutlineLightningBolt size={15} />
                    </span>
                </div>
            </div>
        </div >
    )
};
export default HomePage;